// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3jhti","footer":"styles_footer__NL1ZS","passCodeTooltip":"styles_passCodeTooltip__2B2bW"};